export const ACTIVITY_LOG_TYPE = {
  SET_TASK_STATUS: 'set_task_status',
  UPDATE_TASK_STATUS: 'update_task_status',
  SET_TASK_PLAN_DATE: 'set_task_plan_date',
  UPDATE_TASK_PLAN_DATE: 'update_task_plan_date',
  SET_TASK_ASSIGNEE: 'set_task_assignee',
  UPDATE_TASK_ASSIGNEE: 'update_task_assignee',
}
